// The "How route cards work" support article, opened from the info link beside
// the editor's title. The apps open the same one (Android BlogUrls.routeCardsBlog,
// iOS RouteCardSupportArticle).
//
// `?post_type=article&p=<id>` rather than the pretty permalink: the support site
// 301s the short form to whatever the published permalink is, so the link works
// once the draft goes live.
export const ROUTE_CARD_ARTICLE_ID = 4819;

export const ROUTE_CARD_ARTICLE_URL = `https://support.hiiker.app/?post_type=article&p=${ROUTE_CARD_ARTICLE_ID}`;
